<template>
    <el-dialog  title="货损上传"  :visible="HSSCflag" width="1100px"  @close="closeDialog" :close-oni-click-modal="false" :close-on-press-escape="false" center>
      <div class="hsBox">
         <uploadImgs3 :imgList.sync='imgList'  v-if="jiekouFlag" :max=10 @remove="remove"></uploadImgs3>
      </div>
      <div style="margin: 15px auto" class="el-dialog--center">
        <el-button @click="closeDialog" >取消</el-button>
        <el-button type="primary" @click="saveFn" :loading="addLoad">提交</el-button>
      </div>
  </el-dialog>

</template>

<script>
import uploadImgs3 from '@/components/uploadImgs3.vue'
import { findInStockDbDamageGoods, uploadInStockDbDamageGoods } from '@/api/wms-access'
import DonMessage from '@/utils/message'
export default {
  name: 'huosunshangchuan',
  components: { uploadImgs3
  },
  props: {
    HSSCflag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      imgList: [],
      deleteImgIds: [],
      addLoad: false,
      jiekouFlag: false
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    findInStockDbDamageGoods({ instockId: this.rowData.instockId }).then(res => {
      this.imgList = []
      res.forEach(item => {
        this.imgList.push({ status: 'ready', url: item.fileKeyUrl, id: item.imgId })
      })
      this.jiekouFlag = true
    })
  },
  methods: {
    // 点击凭证放大
    getSrcList (index, arr) {
      let imgArr = arr.slice(index).concat(arr.slice(0, index))
      let urls = []
      imgArr.forEach(item => {
        urls.push(item.url)
      })
      return urls
    },
    remove (file) {
      if (file.id) {
        this.deleteImgIds.push(file.id)
      }
    },

    saveFn () {
      let imgfile = new FormData()
      imgfile.set('params', JSON.stringify({
        deleteImgIds: this.deleteImgIds,
        instockId: this.rowData.instockId
      }))
      this.imgList.forEach(item => {
        if (!item.id) {
          imgfile.append('files', item.raw)
        }
      })
      this.addLoad = true
      uploadInStockDbDamageGoods(imgfile).then(res => {
        this.addLoad = false
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.$emit('update:HSSCflag', false)
        this.$parent.getThreadMasterLists()
      }).catch(error => {
        this.addLoad = false
        DonMessage.error(error.message)
      })
    },
    closeDialog () {
      this.$emit('update:HSSCflag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin: 6px;
  }
}
.hsBox /deep/ .el-upload--picture-card{
  width: 180px;
  height: 130px;
}
.hsBox /deep/.el-upload-list--picture-card .el-upload-list__item{
    width: 180px;
    height: 130px;

}
</style>
